// Module
var code = "<div class=\"form-group\"> <label>Page Name</label> <select class=\"form-control\" data-bind=\"options: State().NameOptions, optionsText: 'PageDisplayName', value: State().SelectedName\"></select> <!--ko if: State().Error--> <p data-bind=\"text: State().Error\" class=\"validation-message\"></p> <!--/ko--> </div>";
// Exports
export default code;